import React, { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AuthPage from './components/auth/AuthPage'
import Editor from './components/editor/Editor'
import ErrorPage from './components/ErrorPage'
import WaitlistPage from './components/WaitlistPage'
import LoadingSpinner from './components/common/LoadingSpinner'
import useAuthStore from './stores/authStore'
import './App.css'

function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-900">
      <LoadingSpinner size="lg" className="mb-4" />
      <div className="text-[1rem] leading-6 font-normal text-white/90 tracking-[-0.025em]">
        Starting Photowhim...
      </div>
    </div>
  )
}

function App() {
  const initializeAuth = useAuthStore(state => state.initializeAuth)
  const isServerUnreachable = useAuthStore(state => state.isServerUnreachable)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const init = async () => {
      await initializeAuth()
      setIsInitialized(true)
    }
    init()
  }, [initializeAuth])

  if (!isInitialized) {
    return <LoadingScreen />
  }

  if (isServerUnreachable) {
    return <ErrorPage />
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <Routes>
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route
          path="/editor"
          element={
            <ProtectedRoute>
              <Editor />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/editor" replace />} />
      </Routes>
    </div>
  )
}

export default App